import { Devices, useViewport } from "./useViewport";

const useDeviceType = () => {
  const device = useViewport();

  return {
    isDesktopDevice: device === Devices.DESKTOP,
    isTabletDevice: device === Devices.TABLET,
    isMobileDevice: device === Devices.MOBILE,
  };
};
export default useDeviceType;
